import { FormikProps, getIn } from 'formik';
import React from 'react';
import {
  Col, Form, Row,
} from 'react-bootstrap';
import { SellerContactPreference, UnsavedSellerContact } from '../../../../structures/models/seller';
import RequiredFieldLabel from '../../Partials/RequiredFieldLabel';
import { SellerDetails } from '../SellerDetailsStep';

type CreateContactFormProps = {
  index: number;
  contact: UnsavedSellerContact;
  formikProps: FormikProps<SellerDetails>;
};

const CreateContactForm: React.FC<CreateContactFormProps> = ({
  index,
  contact,
  formikProps,
}) => {
  const {
    errors,
    setFieldTouched,
    setFieldValue,
  } = formikProps;

  const handleContactPreference = (
    { target }: React.ChangeEvent<HTMLInputElement>,
    preference: SellerContactPreference,
  ): void => {
    // If preference is selected and not already in the values array,
    // append it to the end of the array
    if (
      target.checked
      && !contact.contact_preference.includes(preference)
    ) {
      setFieldValue(
        `contacts[${index}].contact_preference`,
        [...contact.contact_preference, preference],
        true,
      );
    }

    // If preference is not selected, remove it from the values array
    if (!target.checked) {
      setFieldValue(
        `contacts[${index}].contact_preference`,
        contact.contact_preference.filter(
          (i) => i !== preference,
        ),
        true,
      );
    }
    setFieldTouched(`contacts[${index}].contact_preference`);
  };

  return (
    <React.Fragment key={index}>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group
            controlId={`contacts[${index}].contact_preference`}
          >
            <Form.Label className="font-weight-bold small-txt text-muted">
              <RequiredFieldLabel isInvalid={getIn(errors, `contacts[${index}].contact_preference`)}>
                Contact Preference
              </RequiredFieldLabel>
            </Form.Label>
            <Form.Check
              type="checkbox"
              id={`call-checkbox-${index}`}
              label="Call"
              onChange={(e) => handleContactPreference(e, 'call')}
              checked={contact.contact_preference.includes('call')}
            />
            <Form.Check
              type="checkbox"
              id={`text-checkbox-${index}`}
              label="Text"
              onChange={(e) => handleContactPreference(e, 'text')}
              checked={contact.contact_preference.includes('text')}
            />
            <Form.Check
              type="checkbox"
              id={`email-checkbox-${index}`}
              label="Messages / Email"
              onChange={(e) => handleContactPreference(e, 'email')}
              checked={contact.contact_preference.includes('email')}
            />
            <span className={`${getIn(errors, `contacts[${index}].contact_preference`) ? 'is-invalid' : ''}`} />
            <Form.Control.Feedback type="invalid">
              {getIn(errors, `contacts[${index}].contact_preference`)}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CreateContactForm;
